import { render } from "./Chatstream.vue?vue&type=template&id=7484e345"
import script from "./Chatstream.vue?vue&type=script&lang=js"
export * from "./Chatstream.vue?vue&type=script&lang=js"

import "./Chatstream.vue?vue&type=style&index=0&id=7484e345&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__